import { fetchDestinationPriceInfo } from 'actions/CarHireActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

const EmptyList: App.CarHireDestinationAveragePricesList = {
  fetching: true,
  destinations: [],
}

function useCarHireDestinationPriceInfo(params: App.CarHireDestinationPriceInfoParams): App.CarHireDestinationAveragePricesList {
  const dispatch = useAppDispatch()

  const destinationsAveragePrices =
    useAppSelector(state => state.carHire.destinationsPriceInfoList[params.key]) ?? EmptyList

  useEffect(() => {
    if (params) {
      dispatch(fetchDestinationPriceInfo(params))
    }
  }, [dispatch, params])

  return destinationsAveragePrices
}

export default useCarHireDestinationPriceInfo
